import COLORS from '../../../../utils/constants/colors'

const noOrgLandingStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
    padding: '40px 24px',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: COLORS.darkGrey,
    textAlign: 'center',
    marginBottom: 12,
  },
  contact: {
    fontSize: 16,
    color: COLORS.darkGrey,
    textAlign: 'center',
  },
  contactLink: {
    color: COLORS.orange,
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  appsSection: {
    width: '100%',
    marginTop: 40,
  },
  appsTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: COLORS.darkGrey,
    textAlign: 'center',
    marginBottom: 20,
  },
}

export default noOrgLandingStyles
